import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { MatExpansionPanel } from '@angular/material/expansion'
import { select, Store } from '@ngrx/store'
import { OpenAddRentalDialog } from '@tv3/store/overlay/overlay.actions'
import {
  Channel,
  Destroyable,
  Rental,
  selectAllRentals,
  selectRentalsLoaded,
  untilDestroy,
} from '@tokeet-frontend/tv3-platform'
import { SelectRentalDialogService } from '@tv3/shared/dialogs/select-rental-dialog/select-rental-dialog.service'
import { RentalRatesDialogService } from '@tv3/containers/rates/rental-rates-dialog/rental-rates-dialog.service'
import { RentalRatesDialogTab } from '@tv3/containers/rates/rental-rates-dialog/rental-rates-dialog.component'
import { AccountRatesDialogService } from '@tv3/containers/rates/account-rates-dialog/account-rates-dialog.service'
import { AccountRatesDialogTab } from '@tv3/containers/rates/account-rates-dialog/account-rates-dialog.component'

@Component({
  selector: 'app-connect-bdc-wizard-step2',
  templateUrl: './connect-bdc-wizard-step2.component.html',
  styleUrls: ['./connect-bdc-wizard-step2.component.scss'],
})
export class ConnectBDCWizardStep2Component extends Destroyable {
  @ViewChild('start') startStep: MatExpansionPanel
  @Input() channel: Channel

  @Output() prev = new EventEmitter()
  @Output() next = new EventEmitter()
  rentals$ = this.store.pipe(select(selectAllRentals))
  rentalsLoaded$ = this.store.pipe(select(selectRentalsLoaded))

  constructor(
    private selectRentalDialog: SelectRentalDialogService,
    private rentalRatesDialog: RentalRatesDialogService,
    private accountRatesDialog: AccountRatesDialogService,
    private store: Store<any>
  ) {
    super()
  }

  prepareRates() {
    this.selectRentalDialog
      .open({
        title: $localize`Prepare Rates`,
        help: $localize`Select a rental to prepare its rates.`,
        multiple: false,
        required: true,
        selectOnChange: true,
      })
      .pipe(untilDestroy(this))
      .subscribe((rental: Rental) => {
        if (rental) this.rentalRatesDialog.openSide({ rental, tab: RentalRatesDialogTab.Rates })
      })
  }

  channelAdjustment() {
    if (!this.channel?.id) return

    this.accountRatesDialog.open({
      activeTab: AccountRatesDialogTab.ChannelAutomations,
      addChannelAdjustmentForChannelId: this.channel.id,
    })
  }

  onAddRental() {
    this.store.dispatch(OpenAddRentalDialog())
  }

  reset() {
    this.startStep.open()
  }
}
